// ready for code review

import { defineStore } from 'pinia'

export const useErrorRecoveryStore = defineStore('errorRecovery', () => {
    const datadogInstance = useDatadog()

    // State
    const isErrorRecoveryOpen = ref(false)
    const inProgress = {
        retryFailedActions: ref(false),
        refreshPage: ref(false),
    }
    const failureLogs = ref<unknown[]>([])

    // Actions
    const retryFailedActions = async () => {
        // For now retrying last action only
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const lastFailedLog: any = failureLogs.value[failureLogs.value.length - 1]
        if (lastFailedLog) {
            const args = lastFailedLog.args ? lastFailedLog.args : []

            // eslint-disable-next-line no-useless-catch
            try {
                failureLogs.value.pop()
                await lastFailedLog.store[lastFailedLog.name](...args)
                isErrorRecoveryOpen.value = false
            } catch (error: unknown) {
                throw error
            }
        }
    }
    const refreshPage = () => {}

    const setErrorRecoveryModalVisibility = (flag: boolean) => {
        isErrorRecoveryOpen.value = flag
    }

    const addFailedLog = (log: unknown) => {
        const exists = failureLogs.value.some((l: unknown) => {
            return l.store.$id === log.store.$id && l.name === log.name
        })
        if (!exists) {
            failureLogs.value.push(log)
        }
    }
    const trackWithDatadog = (error: Error | string) => {
        if (!datadogInstance) {
            return
        }

        if (typeof error === 'string') {
            datadogInstance.logError(new Error(error), {})
        } else {
            datadogInstance.logError(error, {})
        }
    }

    return {
        inProgress,
        isErrorRecoveryOpen,
        failureLogs,

        retryFailedActions,
        refreshPage,
        setErrorRecoveryModalVisibility,
        addFailedLog,
        trackWithDatadog,
    }
})
